// Header

import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
// import { Spinner } from "./Spinner";

const Header = () => {
  const { quantity } = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const logout = useSignOut();
  const isAuthenticated = useIsAuthenticated();

  const handleLoginIcon = () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Do you want to logout?")) {
      logout();
      navigate("/");
    }
  };
  return (
    <div>
      <div className="container-fluid fixed-top" id="top">
        <div className="container topbar bg-primary d-none d-lg-block">
          <div className="d-flex justify-content-between">
            <div className="top-info ps-2">
              <small className="me-3">
                <i className="fas fa-map-marker-alt me-2 text-secondary"></i>{" "}
                <Link to="/" className="text-white">
                  123 Street, UK
                </Link>
              </small>
              <small className="me-3">
                <i className="fas fa-envelope me-2 text-secondary"></i>
                <Link to="/" className="text-white">
                  Email@Example.com
                </Link>
              </small>
            </div>
            <div className="top-link pe-2">
              <Link to="/" className="text-white">
                <small className="text-white ms-2">Sales and Refunds</small>
              </Link>
            </div>
          </div>
        </div>
        <div className="container px-0">
          <nav className="navbar navbar-light bg-white navbar-expand-xl">
            <Link to="/" className="navbar-brand">
              <img
                src="/assets/logo.png"
                alt="logo"
                style={{ width: "130px", height: "90px" }}
              />
            </Link>
            <button
              className="navbar-toggler py-2 px-3"
              type="button"
              title="btn"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="fa fa-bars text-primary"></span>
            </button>
            <div
              className="collapse navbar-collapse bg-white"
              id="navbarCollapse"
            >
              <div className="navbar-nav mx-auto">
                <Link to="/" className="nav-item nav-link active">
                  Home
                </Link>
                <Link to="/about" className="nav-item nav-link">
                  About
                </Link>
                <Link to="/shop" className="nav-item nav-link">
                  Shop
                </Link>

                <Link to="/contact" className="nav-item nav-link">
                  Contact
                </Link>
              </div>
              <div className="d-flex m-3 me-0">
                <button
                  className="btn-search btn border border-secondary btn-md-square rounded-circle bg-white me-4"
                  data-bs-toggle="modal"
                  data-bs-target="#searchModal"
                  title="btn"
                >
                  <i className="fas fa-search text-primary"></i>
                </button>
                <Link to="/cart" className="position-relative me-4 my-auto">
                  <i className="fa fa-shopping-bag fa-2x"></i>
                  <span
                    className="position-absolute bg-secondary rounded-circle d-flex align-items-center justify-content-center text-dark px-1"
                    style={{
                      top: "-5px",
                      left: "15px",
                      height: "20px",
                      minWidth: "20px",
                    }}
                  >
                    {quantity}
                  </span>
                </Link>
                {isAuthenticated ? (
                  <div
                    onClick={handleLoginIcon}
                    className="my-auto"
                    title="icon"
                  >
                    <i className="fas fa-user fa-2x"></i>
                  </div>
                ) : (
                  <Link to="/login" className="my-auto" title="icon">
                    <i className="fas fa-user fa-2x"></i>
                  </Link>
                )}
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;
